module.exports = __webpack_public_path__ + "static/media/project-info.93575576.svg";